import React, { memo } from 'react';

export const ToggleQuestion = memo(function ToggleQuestion() {
    return (<div>Toggle question.</div>);
});
